import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

// Multibrand-UI Components
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import Text from '@zg-rentals/multibrand-ui/lib/Text';

import { RMWContext } from 'app/shared/providers/RMWContext';

// styles
import './style.scss';

const propTypes = {
    actionText: PropTypes.string.isRequired,
    noMargin: PropTypes.bool,
    className: PropTypes.string,
    lowlight: PropTypes.bool,
};

const defaultProps = {
    noMargin: false,
    className: '',
    lowlight: false,
};

function ListingActivationTerms({
    actionText, noMargin, className, lowlight,
}) {
    const { paths } = React.useContext(RMWContext);

    return (
        <div
            className={cx(className, 'ListingActivationTerms', {
                'ListingActivationTerms-no-margin': noMargin,
            })}
        >
            <Text lowlight={lowlight} type="body-tiny">
                {actionText}
                , you agree to comply with our&nbsp;
                <Link to={paths.corpTermsURL} target="_blank">Terms of Use</Link>
                ,&nbsp;
                <Link to={paths.rentalTermsURL} target="_blank">Rental User Terms</Link>
                , and&nbsp;
                <Link to={paths.pledgeURL} target="_blank">Respectful Renting Pledge</Link>
                .
            </Text>
        </div>
    );
}

ListingActivationTerms.propTypes = propTypes;
ListingActivationTerms.defaultProps = defaultProps;

export default ListingActivationTerms;
